<template>
  <div
    v-if="view==='num'"
  >
    <v-layout
      :class="{active:active}"
      class="numWrap rounded px-2 py-1 nowrap"
      align-center
    >
      <slot />
      <v-icon
        v-if="active"
        light
        color="orange"
        small
        class="ml-1"
      >
        check_circle
      </v-icon>
      <v-icon
        v-else
        light
        small
        color="grey"
        class="ml-1"
      >
        check_circle_outline
      </v-icon>
    </v-layout>
  </div>
  <v-layout
    v-else-if="view==='time' && active"
    :class="{dark: dark}"
    class="timeWrap rounded px-1 py-1 nowrap"
    align-center
  >
    <v-icon
      light
      small
      color="green"
      class="mr-1"
    >
      check_circle
    </v-icon>
    已鎖定返金巧幣，有效時間：
    <Countdown
      :endTime="activeItem.expire"
    >
      <template #default="slotProps">
        {{ slotProps.minute }}:{{ slotProps.second }}
      </template>
    </Countdown>
  </v-layout>
</template>
<script>
export default {
  props: {
    view: String,
    item: Object,
    itemid: String,
    dark: Boolean,
  },
  data () {
    return {
      countdownData: window.countdownData,
    }
  },
  computed: {
    clickedItemids () {
      return this.$store.state.tpsp.clickedItemids
    },
    activeItem () {
      return this.clickedItemids.find(item => item.tradeid === this.item.tradeid)
    },
    active () {
      return !!this.activeItem && this.activeItem.expire > this.countdownData.currTime
    },
  },
  mounted () {
  },
  methods: {

  },
}
</script>
<style lang="postcss" scoped>
.numWrap {
  background: #fdf2e8;
  color: #000;
  &.active {
   background: #FCE8C8;
  }
}

.timeWrap {
  background: #fafafa;
  color: #000;
  font-size: 12px;
  &.dark {
    background: #707070;
    color: #fff;
  }
}
</style>
